import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=2c46654e&scoped=true&lang=pug&"
var script = {}
import style0 from "./SideBar.vue?vue&type=style&index=0&id=2c46654e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c46654e",
  null
  
)

export default component.exports